import React from 'react'
import PropTypes from 'prop-types'
import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'
import exportToImage from '../../modules/utils/exports'
import { formatAmount, formatPercentage } from '../../modules/utils/formatters'
import { Exportable, GlobalStyle } from './ComparatorBarChart.styles'

const ComparatorBarChart = ({ comparator, categories, data, distValue, fileName, height, id, inputBarChartRef }) => {
  const serie = () => {
    if (comparator) {
      return data
    } else {
      return [{ data }]
    }
  }

  const options = {
    accessibility: { enabled: false },
    chart: { height, type: 'bar' },
    title: {
      text: ''
    },
    subtitle: {
      text: ''
    },
    xAxis: {
      categories,
      title: { text: null }
    },
    yAxis: {
      min: 0,
      title: {
        text: ''
      },
      labels: {
        overflow: 'justify'
      }
    },
    tooltip: {
      formatter: function () {
        if (distValue === 'amount') {
          return `${this.x}: <strong>$${formatAmount(parseInt(this.y ?? 0, 10))} millones</strong>`
        } else if (distValue === 'oc') {
          return `${this.x}: <strong>${formatAmount(parseInt(this.y ?? 0, 10))} órdenes de compra</strong>`
        } else {
          return `${this.x}: <strong>${formatPercentage(this.y)}</strong>`
        }
      }
    },
    plotOptions: {
      bar: {
        minPointLength: 3,
        dataLabels: {
          enabled: true,
          formatter: function () {
            if (distValue === 'amount') {
              return `$${formatAmount(this.point.y)}`
            } else if (distValue === 'oc') {
              return `${this.point.y} órdenes de compra`
            } else {
              return formatPercentage(this.point.y)
            }
          }
        }
      }
    },
    credits: {
      enabled: false
    },
    series: serie()
  }
  const exportData = () => exportToImage(id, fileName)

  return (
    <>
      <GlobalStyle />
      <Exportable id={id}>
        <HighchartsReact highcharts={Highcharts} options={options} />
      </Exportable>
      <Exportable ref={inputBarChartRef} onClick={exportData} />
    </>
  )
}

ComparatorBarChart.defaultProps = {
  comparator: false,
  id: 'barChart'
}

ComparatorBarChart.propTypes = {
  categories: PropTypes.arrayOf(PropTypes.string),
  comparator: PropTypes.bool,
  data: PropTypes.oneOfType([
    PropTypes.shape({
      amounts: PropTypes.arrayOf(
        PropTypes.shape({
          name: PropTypes.string,
          data: PropTypes.arrayOf(PropTypes.number)
        })
      ),
      orders: PropTypes.arrayOf(
        PropTypes.shape({
          name: PropTypes.string,
          data: PropTypes.arrayOf(PropTypes.number)
        })
      )
    }),
    PropTypes.arrayOf(
      PropTypes.shape({
        color: PropTypes.string,
        data: PropTypes.arrayOf(PropTypes.number),
        name: PropTypes.string
      })
    )
  ]),
  distValue: PropTypes.string,
  fileName: PropTypes.string,
  height: PropTypes.number,
  id: PropTypes.string,
  inputBarChartRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.instanceOf(window.HTMLDivElement) })
  ])
}

export default ComparatorBarChart
